module.exports = __webpack_public_path__ + "static/media/JiaoYu1.823c92a8.png";